import { app,rtdb } from "../firebase";
import { getDatabase, ref, set, push, update, remove,get,child } from "firebase/database";
import { updatePricingCount } from "./companyService";

const companiesCollection = 'companies';

export async function countPricings(companyId) {
  if (!companyId) throw new Error("Nenhum ID de empresa fornecido.");

  const rootRef = ref(rtdb);
  const snap = await get(child(rootRef, `companies/${companyId}/pricing`));

  const data = snap.val();
  if (!data) return 0;

  const arr = Object.values(data);
  const activeOnly = arr.filter((x) => !x?.deleted); 
  return activeOnly.length;
}

export const getPricings = async (companyId) => {
  const db = getDatabase(app);
  if (!companyId) throw new Error("Nenhum ID de empresa fornecido.");

  const dbRef = ref(db);
  const snapshot = await get(child(dbRef, `companies/${companyId}/pricing`));

  if (snapshot.exists()) {
    const data = snapshot.val();
    return Object.entries(data).map(([id, value]) => ({
      id,
      ...value,
    }));
  }
  return [];
};

export const getPricingById = async (companyId,pricingId) => {
  const db = getDatabase(app);
  if (!companyId) throw new Error("Nenhum ID de empresa fornecido.");
  if (!pricingId) throw new Error("Nenhum ID de precificação fornecido.");
  const dbRef = ref(db);
  const snapshot = await get(child(dbRef, `companies/${companyId}/pricing/${pricingId}`));
  return snapshot.exists() ? { id: pricingId, ...snapshot.val() } : null
};


export async function deletePricing(company, pricingId) {
  const companyId = company?.companyId;
  const companyPricingCount = company?.pricingCount || await countPricings(companyId);


  if (!companyId || !pricingId) throw new Error("ID inválidos para exclusão");
  const db = getDatabase(app);
  await remove(ref(db, `companies/${companyId}/pricing/${pricingId}`))
    .then(() => {
      updatePricingCount(companyId,companyPricingCount-1)
    })
    .catch(error => console.error("Erro deletar precificação com id: ",pricingId,"Error: ", error));
  
}

export const savePricingStepper1Data = (companyId, data) => {
  const db = getDatabase(app);
 
  if (!companyId) {
    companyId = push(ref(getDatabase(app), companiesCollection)).key; 
  }

  const companyData = {
    employee: {},
    fixedCosts: {},
    variableCosts: {}
  };

  // Mapeia funcionários
  if (Array.isArray(data.funcionarios) && data.funcionarios.length > 0) {
    data.funcionarios.forEach(func => {
      const empId = push(ref(db, `companies/${companyId}/employee`)).key;
      companyData.employee[empId] = func;
    });
  }
  
  // Mapeia custos fixos
  if (Array.isArray(data.custosFixos) && data.custosFixos.length > 0) {
    data.custosFixos.forEach(func => {
      const empId = push(ref(db, `companies/${companyId}/fixedCosts`)).key;
      companyData.fixedCosts[empId] = func;
    });
  }

  // Mapeia custos variáveis
  if (Array.isArray(data.custosVariaveis) && data.custosVariaveis.length > 0) {
    data.custosVariaveis.forEach(func => {
      const empId = push(ref(db, `companies/${companyId}/variableCosts`)).key;
      companyData.variableCosts[empId] = func;
    });
  }

  const sanitizedData = removeUndefined(companyData);

  update(ref(db, `companies/${companyId}`), sanitizedData)
  .then(() => console.log("Dados salvos com sucesso!"))
  .catch(error => console.error("Erro ao salvar:", error));

  return sanitizedData;
};

function removeUndefined(obj) {
  return JSON.parse(JSON.stringify(obj));
}

const limparObjetos = (obj) => {
  if (Array.isArray(obj)) {
    return obj
      .map(limparObjetos)
      .filter((item) => {
        if (typeof item === "object" && !Array.isArray(item)) {
          return Object.values(item).some(
            (v) => v !== "" && v !== null && v !== undefined
          );
        }
        return item !== "" && item !== null && item !== undefined;
      });
  } else if (typeof obj === "object" && obj !== null) {
    const novoObj = {};
    Object.entries(obj).forEach(([key, value]) => {
      const valLimpo = limparObjetos(value);
      if (
        valLimpo !== "" &&
        valLimpo !== null &&
        valLimpo !== undefined &&
        (typeof valLimpo !== "object" || Object.keys(valLimpo).length > 0)
      ) {
        novoObj[key] = valLimpo;
      }
    });
    return novoObj;
  }
  return obj;
};

const prepararPayload = (formData) => {
  const { custosFixos, custosVariaveis, funcionarios,dadosCliente, ...resto } = formData;

  let payloadLimpo = limparObjetos(resto)

  if (dadosCliente?.id) {
    payloadLimpo.idCliente = dadosCliente.id;
  }

  return payloadLimpo;
};

const preparaPayloadResume = (formData) => {
  const { impostoPercent, lucroPercent, sugestedPrice } = formData;

  let payloadLimpo = limparObjetos({ impostoPercent, lucroPercent, sugestedPrice })

  return payloadLimpo;
}

export const updateResume = async (company, formData) => {
  const db = getDatabase(app);
  const companyId = company?.companyId;
  let pricingId = formData?.id;

  await update(ref(db, `companies/${companyId}/pricing/${pricingId}`), preparaPayloadResume(formData))
  .then(() => {
    console.log("Dados salvos com sucesso!")
  })
  .catch(error => console.error("Erro ao salvar:", error));
}

export const savePricingStepper2Data = async (company, formData) => {
  const payload = prepararPayload(formData);
  const db = getDatabase(app);

  const companyId = company?.companyId;
  const companyPricingCount = company?.pricingCount || await countPricings(companyId);
  let pricingId = formData?.id; 

  if (!pricingId) {
    const newRef = push(ref(db, `companies/${companyId}/pricing`));
    pricingId = newRef.key;
    await set(newRef, { id: pricingId, ...payload })
    .then(() => {
      console.log("Dados salvos com sucesso!")
      updatePricingCount(companyId,companyPricingCount+1)
    })
    .catch(error => console.error("Erro ao salvar:", error));
    return pricingId;
  } else {
    await update(ref(db, `companies/${companyId}/pricing/${pricingId}`), payload)
    .then(() => {
      console.log("Dados salvos com sucesso!")
      updatePricingCount(companyId,companyPricingCount)
    })
    .catch(error => console.error("Erro ao salvar:", error));
    return pricingId;
  }
 
};



